// Google OAuth configuration
export const GOOGLE_CLIENT_ID = '178635765634-f80q77ebci4bo7qh37491vjkast97771.apps.googleusercontent.com';